import SecondaryDefaultButton from '@/components/buttons/secondary/DefaultButton';
import styled from 'styled-components';


const SecondaryOuterGlowButton = styled(SecondaryDefaultButton)`

`;

export default SecondaryOuterGlowButton;
